import { Constants } from "constants/Constants";
import { getStoredData } from "./fnAsyncStorage";

type Props = {
  chartRef: React.RefObject<HTMLDivElement>;
};

const generatePDF = async ({
  chartRef,
}: Props): Promise<{ blob: Blob; filename: string } | null> => {
  if (!chartRef.current) return null;

  const apiUrl = Constants.API_URL;
  const token = await getStoredData("token");

  const headers = new Headers();
  const baseUrl = `${apiUrl}/export/pdf`;

  headers.append("Content-Type", "application/json");

  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }

  // Récupération des styles de la page
  const docStyles = Array.from(document.styleSheets)
    ?.map((sheet) => {
      try {
        return Array.from(sheet.cssRules || [])
          ?.map((rule) => rule.cssText)
          .join("\n");
      } catch (e) {
        console.warn("Impossible d'accéder aux styles d'un fichier externe.");
        return "";
      }
    })
    .join("\n");

  const canvases = chartRef.current.getElementsByTagName("canvas");
  // eslint-disable-next-line no-restricted-syntax
  for (const canvas of canvases) {
    const img = document.createElement("img");
    img.src = canvas.toDataURL("image/png");
    img.width = canvas.width;
    img.height = canvas.height;
    canvas.replaceWith(img);
  }

  const htmlContent = `
    <html>
      <head>
        <meta charset="UTF-8">
        <style>${docStyles}</style>
      </head>
      <body>
        ${chartRef.current.outerHTML}
      </body>
    </html>
  `;

  const response = await fetch(baseUrl, {
    method: "POST",
    headers,
    body: JSON.stringify({ html: htmlContent }),
  });

  const contentDisposition = response.headers.get("Content-Disposition");
  let filename = "bilan.pdf";

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) {
      [, filename] = match;
    }
  }

  if (response.ok) {
    const blob = await response.blob();
    return { blob, filename };
  }

  return null;
};

export default generatePDF;
